import { ArquitetoType } from '../contexts/ArquitetoContext/types';
import crm from './crm';

export const ArquitetoService = {
    search: (filtros:any=null) => {
        return crm.get(`/arquiteto`, {params: filtros});
    },   
    save: (dados:ArquitetoType) => {
        return crm.post(`/arquiteto`, dados);
    },   
    remove: (idArquiteto:number) => {
        return crm.delete(`/arquiteto/${idArquiteto}`);
    },   
};

